module.exports = __webpack_public_path__ + "img/2010 winteressen 009.df901cc5.jpg";